// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"499":"232df416","872":"6051520b"}[chunkId] + ".js";
};